// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M10.5 2L13.25 4.75L10.5 7.5M13.25 4.75H2.75',
  'M5.5 8.5L2.75 11.25L5.5 14M2.75 11.25H13.25',
];
